module.exports = __webpack_public_path__ + "static/media/cb.b73c7938.jpg";